import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next/initReactI18next";
import {
  getOptions,
  NameSpaceKeys,
} from "@bfc-software/bfc-web-ui/i18n/settings";

function initI18next(lang: string, namespace: NameSpaceKeys) {
  const i18nInstance = createInstance();
  i18nInstance.use(initReactI18next).init(getOptions({ lang, namespace }));
  return i18nInstance;
}

type CreateTranslation = {
  lang: string;
  namespace: NameSpaceKeys;
  options?: Record<string, string>;
};

/** Not a hook: safe inside `useMemo`. `useTranslation` below is only its per-render wrapper. */
export function createTranslation({
  lang,
  namespace,
  options = {},
}: CreateTranslation) {
  const i18nextInstance = initI18next(lang, namespace);
  return {
    t: i18nextInstance.getFixedT(lang, namespace, options.keyPrefix),
    i18n: i18nextInstance,
  };
}

export function useTranslation(args: CreateTranslation) {
  return createTranslation(args); // behaviour unchanged: fresh instance per render
}
